// extracted by mini-css-extract-plugin
export default {"p_tye":"c704115a75","slcted":"_2d61be32d7","slc_color":"_911847ec28","item_p":"_712927488f","r0":"ae0bc3da21"};